import { toast } from "react-toastify";
import * as actionTypes from "./actionTypes";
import authService from "../../api/authService";
import {
  REGISTER_FASE_VALIDATION,
  REGISTER_FASE_IDENTIFICATION,
  REGISTER_FASE_CONFIRMATION,
  REGISTER_FASE_COMPLETED,
} from "../../infrastructure/appConstants";
import { resetScroll } from "../../util/JsUtils";

export const setRegisterCustomer = (currentCustomer, fase) => {
  return {
    type: actionTypes.REGISTER_USER,
    payload: { currentCustomer, fase },
  };
};

export const registerIdentification = (data) => async (dispatch) => {
  try {
    const response = await authService.registerIdentification(data);
    //Actualizando fase  a validacion
    dispatch(setRegisterCustomer(response.data, REGISTER_FASE_VALIDATION));
    toast.success(response.message);
  } catch (error) {
    throw error;
  }
};

export const registerValidation = (data) => async (dispatch) => {
  try {
    const response = await authService.registerValidation(data);
    //Actualizando fase  a confirmacion
    dispatch(setRegisterCustomer(response.data, REGISTER_FASE_CONFIRMATION));
    toast.success(response.message);
  } catch (error) {
    throw error;
  }
};

export const registerConfirmation = (data, currentCustomer) => async (
  dispatch
) => {
  try {
    const response = await authService.registerConfirmation(data);
    //Actualizando fase  a confirmacion
    dispatch(setRegisterCustomer(currentCustomer, REGISTER_FASE_COMPLETED));
    resetScroll();
    toast.success(response.message);
  } catch (error) {
    throw error;
  }
};

export const cleanRegister = () => (dispatch) => {
  try {
    //Clean data register
    dispatch(setRegisterCustomer(null, REGISTER_FASE_IDENTIFICATION));
  } catch (error) {
    throw error;
  }
};

export const sendVerification = async (data) => {
  try {
    return await authService.sendVerification(data);
  } catch (error) {
    throw error;
  }
};
